<div class="inputs-container" #container>
        <div class="note-placeholder">
            <div class="note" *ngIf="selectedValues?.length">Deaktivieren</div>
            <app-input-flat-select-list [name]="name + '-left'"
                                        class="select-list list-add"
                                        [label]="getLabelLeft()"
                                        [options]="options"
                                        [button_faIcon]="'fa-angle-double-right'"
                                        [buttonOptionDisabled_faIcon]="'fa-lock'"
                                        [(ngModel)]="selectedValues"
                                        [placeholderHtml]="placeholderHtmlLeft"
                                        [compareByFn]="compareByFn"
                                        (blur)="onBlur()"
                                        (focus)="onFocus()"
                                        (ngModelChange)="onLeftModelChange()">
            </app-input-flat-select-list>
        </div>


        <div class="note-placeholder">
            <div class="note" *ngIf="notSelectedValues?.length">Aktivieren</div>
            <app-input-flat-select-list [name]="name + '-right'"
                                        class="select-list list-remove"
                                        [label]="getLabelRight()"
                                        [options]="options"
                                        [button_faIcon]="'fa-angle-double-left'"
                                        [buttonOptionDisabled_faIcon]="'fa-lock'"
                                        [(ngModel)]="notSelectedValues"
                                        [placeholderHtml]="placeholderHtmlRight"
                                        [compareByFn]="compareByFn"
                                        (blur)="onBlur()"
                                        (focus)="onFocus()"
                                        (ngModelChange)="onRightModelChange()">
            </app-input-flat-select-list>
        </div>

</div>
